import { createContext, useContext } from 'react';
import type { RegistryApi } from '../api/registryApi';
import type { RegistryMe, RegistryPermissionId } from '../api/registryApiTypes';

export interface RegistrySession {
  me: RegistryMe;
  api: RegistryApi;
  signOut: () => void;
}

/** Null in the pure-mock console (REACT_APP_REGISTRY_MOCK=true), which has no signed-in user. */
export const RegistrySessionContext = createContext<RegistrySession | null>(null);

export function useRegistrySession(): RegistrySession | null {
  return useContext(RegistrySessionContext);
}

export function hasRegistryPermission(
  session: RegistrySession | null,
  permission: RegistryPermissionId,
): boolean {
  return Boolean(session?.me.permissions.some((item) => item.id === permission));
}
